import React, { useRef, useEffect, useState } from 'react';
import {
  SDrawerOrModal,
} from 'shj-components'
import { Form, TreeSelect, Radio, Select, Button, Input, Space, message } from 'antd';
import { useUpdateEffect } from 'ahooks'
import { ExclamationCircleOutlined } from '@ant-design/icons'

export default function EditSpecConfigModal ({
  editId = '',
  editData = {},
  openModal = false,
  setOpenModal = (a) => ({}),
  specsArgMap = {},
  confirm = (a) => ({}),
  addConfirm = (a) => ({}),
})  {
  const [ form ] = Form.useForm();
  const isGeneral = Form.useWatch('isGeneral', form);

  const [serviceLoading, setServiceLoading] = useState(false);

  useEffect(() => {
    if (!editId) {
      return;
    }
    form.setFieldValue('includeValueIds', editData?.spaceSpecParamValues?.map((item: any) => item.id))
  }, [editData])

  const onSubmitService = () => {
    form.validateFields().then((value: any) => {
      if (!editId) {
        addConfirm(value);
      } else {
        confirm(value);
      }
    })
  }

  return (
    <div>
      <SDrawerOrModal
        title={'编辑配置'}
        mode="modal"
        open={openModal}
        onCancel={() => setOpenModal(false)}
        onOk={onSubmitService}
        loading={serviceLoading}
        width="500px"
      >
        <Form form={form} labelWrap={true} layout='vertical' style={{ marginTop: '10px' }}>
          <Form.Item
            name='includeValueIds'
            label={editData?.spaceSpecParamName}
            rules={[{
              required: true,
            }]}
          >
            <Select
              placeholder='请选择'
              mode={'multiple'}
              options={[{ id: '0', argValue: '通用' }, ...(specsArgMap?.[editData?.spaceSpecParamId] || [])]}
              fieldNames={{ label: 'argValue', value: 'id' }}
            ></Select>
          </Form.Item>
        </Form>
      </SDrawerOrModal>
    </div>
  )
}
